import { useHistory, useParams } from "react-router-dom";
import { useRef, useState } from "react";
import { Col, message, Row } from "antd";

import Button from "@components/Button";
import Table from "@components/Table";
import { ISubIndustry } from "@types";
import AddSubIndustry from "./AddSubIndustry";
import {
  useDeleteSubIndustryMutation,
  useFetchSubIndustriesQuery,
} from "@services";
import { checkPermission } from "@utils";
import { permissions } from "@router";
import { getColumns } from "./config";
import customErrorMessage from "@/components/CustomErrorMessage";

const SubIndustry = () => {
  let sub_industry_id = useRef<any>(null);
  const history = useHistory();
  const [pageSize, setPageSize] = useState(10);

  const [page, setPage] = useState(1);
  const { industry_id: id } = useParams<{ industry_id: string }>();
  const { data, isLoading, refetch } = useFetchSubIndustriesQuery({
    id,
    page,
    page_size: pageSize,
  });
  const [selectedSubIndustry, setSelectedSubIndustry] =
    useState<null | ISubIndustry>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [deleteSubIndustry, { isLoading: isDeleting }] =
    useDeleteSubIndustryMutation();
  const { data: sub_industries, pagination } = data || {};

  const editSubIndustry = (
    sub_industry: ISubIndustry,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setSelectedSubIndustry(sub_industry);
    setIsVisible(true);
  };

  const handleDelete = async (
    id: number,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    sub_industry_id.current = id;
    try {
      await deleteSubIndustry({ id }).unwrap();
      refetch();
      message.success("Sub-Industry deleted successfully!");
    } catch (err: any) {
      customErrorMessage(err?.message);
      console.log(err);
    }
  };

  const columns = getColumns({
    handleDelete,
    editSubIndustry,
    sub_industry_id,
    isDeleting,
  });
  const { sector_id } = useParams<{ sector_id: string }>();

  return (
    <>
      {isVisible ? (
        <AddSubIndustry
          selectedSubIndustry={selectedSubIndustry}
          setSelectedSubIndustry={setSelectedSubIndustry}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          refetchSubIndustries={refetch}
        />
      ) : null}
      <div className="appTitle text-base font-[500] mx-5">
        <span
          className="cursor-pointer"
          onClick={() => history.push("/sectors")}
        >
          {" "}
          Sectors
        </span>{" "}
        {">"}{" "}
        <span
          className="cursor-pointer"
          onClick={() => history.push(`/sectors/${sector_id}`)}
        >
          {" "}
          Industry{" "}
        </span>{" "}
        {">"} Sub-Industry
      </div>

      <div className="bg-white p-4 sm:p-5">
        <div className="jobCreationBar  sticky top-0 z-10 bg-themeCore px-14 py-6 rounded-lg flex justify-between items-center mb-7">
          <div className="title text-white font-[500] text-3xl uppercase">
            Sectors, Industry & Sub-Industry
          </div>
          <div className="action-buttons flex items-center gap-2">
            {checkPermission(permissions.CREATE_SUB_INDUSTRY) && (
              <Button variant="buttonWhite" onClick={() => setIsVisible(true)}>
                Add Sub-Industry
              </Button>
            )}
          </div>
        </div>

        <div className="rounded-lg">
          <Table
            data={sub_industries}
            columns={columns}
            isLoading={isLoading}
            pagination={true}
            count={pagination?.count}
            onChangePage={setPage}
            onPageSizeChange={setPageSize}
            page={page}
          />
        </div>
      </div>
    </>
  );
};

export default SubIndustry;
